export enum EventInputType {
	DRAG = 'drag',
	KEYBOARD = 'keyboard',
	MOUSE = 'mouse',
	POINTER = 'pointer',
	TOUCH = 'touch',
	WINDOW = 'window',
}
